import React, { useState } from "react";
import Swal from "sweetalert2";
import { useStore } from "../../context";
import { server } from "../../utils";
import { httpGet, httpPost } from "../../servicios";
import UserAnai from "../../models/UserAnai";
import logoanai from "../../images/logos/logoanai.png";

export default function RecuperacionClaveEst() {
  const { state } = useStore();
  const [loading, setLoading] = useState(false);
  const [emailEst, setEmailEst] = useState("");
  const [nomEst, setNomEst] = useState("");
  const [pass, setPass] = useState("");
  const [userName, setUserName] = useState("");
  const [emailTeams, setEmailTeams] = useState("");

  async function verificarUsuario(event) {
    event.preventDefault();
    setLoading(true);
    httpGet(`${server}user/?codigo=${emailTeams.trim()}`, state.token)
      .then((res) => {
        setNomEst(res.data.nom_est);
        setPass(res.data.password);
        if (res.data.username) {
          setUserName(res.data.username);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Correo institucional (TEAMS) Incorrecto!",
            confirmButtonColor: "#0d1b3e",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudo verificar el usuario.",
          confirmButtonColor: "#0d1b3e",
        });
      });
  }

  async function sendEmail(event) {
    event.preventDefault();
    setLoading(true);
    const userAnai = new UserAnai(userName, pass, nomEst, emailEst);
    httpPost(`${server}sendmail`, userAnai, state.token)
      .then(() => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Correo Enviado",
          text: "Correo Electrónico Enviado! Gracias",
          confirmButtonColor: "#0d1b3e",
        });
      })
      .catch(() => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error en enviar correo...!",
          confirmButtonColor: "#0d1b3e",
        });
      });
  }

  return (
    <div className="login-bg">
      <div className="login-card" style={{ maxWidth: 460 }}>
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">🔑 Recuperar Contraseña</div>
        <div className="login-subtitle">Estudiantes ANAI</div>

        {userName === "" ? (
          <form onSubmit={verificarUsuario} style={{ width: "100%" }}>
            <div className="modern-input-group">
              <label>Correo Institucional (TEAMS)</label>
              <input
                type="email"
                placeholder="correo@anai.edu.ec"
                value={emailTeams}
                onChange={(e) => setEmailTeams(e.target.value)}
                required
                autoFocus
              />
            </div>
            <button
              type="submit"
              className="btn-modern btn-primary"
              disabled={loading}
            >
              {loading ? (
                <span className="modern-spinner" style={{ width: 22, height: 22 }} />
              ) : (
                "Continuar"
              )}
            </button>
          </form>
        ) : (
          <form onSubmit={sendEmail} style={{ width: "100%" }}>
            <div className="modern-input-group">
              <label>Estudiante</label>
              <input type="text" value={nomEst} readOnly />
            </div>
            <div className="modern-input-group">
              <label>Correo del Representante</label>
              <input
                type="email"
                placeholder="representante@email.com"
                value={emailEst}
                onChange={(e) => setEmailEst(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn-modern btn-primary"
              disabled={loading}
            >
              {loading ? (
                <span className="modern-spinner" style={{ width: 22, height: 22 }} />
              ) : (
                "📧 Enviar correo"
              )}
            </button>
            <button
              type="button"
              className="btn-modern btn-outline"
              style={{ marginTop: 12 }}
              onClick={() => (window.location = "/")}
            >
              ← Volver al Inicio
            </button>
          </form>
        )}

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
}
